import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eEstadoContratista, eTypeResult, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { IContratistaModel } from 'src/app/models/interfaces/contratista/IContratistaModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-configuracion-contratista-registrar',
  templateUrl: './configuracion-contratista-registrar.component.html',
  styleUrls: ['./configuracion-contratista-registrar.component.css']
})
export class ConfiguracionContratistaRegistrarComponent implements OnInit {
  model: IContratistaModel = new ContratistaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaSedes: SedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceContratista: ContratistaService,
    private companiaService: CompaniaService,
    private sedeService: SedeService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_CONTRATISTA).subscribe((data) => {
      this.listaEstados = data.items;
    });
    this.model.idEstado = eEstadoContratista.ACTIVO;

    let filterSede: IFilterSedeModel = new FilterSedeModel();
    this.sedeService
      .getAllList(filterSede)
      .subscribe((data: SedeModel[]) => {
        this.listaSedes = data;
      });

    let filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceContratista.submit(this.model).subscribe((result: ActionResultModel) => {
            if(result.type!=eTypeResult.SUCCESS){
              this.alertDialogService.open(result.message);
            }
            else{
            this.alertDialogService.open("El contratista fue registrado");
            this.router.navigate(['/configuracion', 'contratistas']);  
            }
          });
        }
      });
    }
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
